import React, { memo, useEffect, useState } from "react";
import ProductsTable from "components/Admin/Tables/ProductsTable";
import { makeStyles, AppBar, Tabs, Tab } from "@material-ui/core";
import TabPanel from "components/Admin/TabPanel";
import FiltersTable from "components/Admin/Tables/FiltersTable";
import { fetchProductsList, selectLoading, setProducts } from "./productsAdminSlice";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
function a11yProps(index: number) {
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
}));

const ProductsWidget: React.FC = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const location: any = useLocation();
  const [value, setValue] = useState(location?.state?.type === "multisplit" ? 1 : 0);
  const isFetching = useSelector(selectLoading);
  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    if (!isFetching) {
      dispatch(setProducts([]));

      setValue(newValue);
      if (newValue == 0) {
        dispatch(fetchProductsList("product"));
      } else if (newValue == 1) {
        dispatch(fetchProductsList("multisplit"));
      }
    }
  };

  useEffect(() => {
    dispatch(fetchProductsList(location?.state?.type === "multisplit" ? "multisplit" : "product"));
    return () => {
      dispatch(setProducts([]));
    };
  }, [dispatch]);

  return (
    <div className={classes.root}>
      <AppBar position="static" color="default">
        <Tabs
          value={value}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
          onChange={handleChange}
        >
          <Tab label="Климатици" {...a11yProps(0)} />
          <Tab label="Мултисплит" {...a11yProps(1)} />
          <Tab label="Стойности на филтри" {...a11yProps(2)} />
        </Tabs>
      </AppBar>

      <TabPanel value={value} index={0}>
        <ProductsTable type={"product"} />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <ProductsTable type={"multisplit"} />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <FiltersTable objectType={"product"} />
      </TabPanel>
    </div>
  );
};

export default memo(ProductsWidget);
